import { render, staticRenderFns } from "./VirtualView.vue?vue&type=template&id=7a03a125"
import script from "./VirtualView.vue?vue&type=script&lang=js"
export * from "./VirtualView.vue?vue&type=script&lang=js"
import style0 from "./VirtualView.vue?vue&type=style&index=0&id=7a03a125&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports